export var ChangePaymentDueDateScreen;
(function (ChangePaymentDueDateScreen) {
    ChangePaymentDueDateScreen["EXECUTION_ERROR_SCREEN"] = "execution_error_screen";
    ChangePaymentDueDateScreen["INITIAL_SCREEN"] = "change_payment_due_date";
    ChangePaymentDueDateScreen["SELECT_DAY_ERROR_SCREEN"] = "select_day_error_screen";
    ChangePaymentDueDateScreen["SUCCESSFUL_SCREEN"] = "successful_screen";
    ChangePaymentDueDateScreen["DEFAULT_SCREEN"] = "default_screen";
})(ChangePaymentDueDateScreen || (ChangePaymentDueDateScreen = {}));
